import { ConfigContainer, ConfigContainerChild, ContainerTemplate } from "../types";

export const getPagesContainerIndex = (children: Array<ConfigContainer | ConfigContainerChild>) => {
  if (!children?.length) return -1;

  return children.findIndex(({ templateName }) => templateName === ContainerTemplate.Pages);
};

export const getPagesContainer = (children: Array<ConfigContainer | ConfigContainerChild>): ConfigContainer => {
  if (!children) return null;

  const pageContainerIndex = getPagesContainerIndex(children);

  return pageContainerIndex >= 0 ? JSON.parse(JSON.stringify(children[pageContainerIndex])) : null;
};
